/**
 * Shared campaign identity for the public-page preview.
 *
 * These previews mirror the portal (DhofarPortal-Frontend khareef-photos
 * feature), so the palette and the logo lockup are kept in one place here and
 * the values match the portal's SCSS variables.
 */
export const BRAND = {
  purple: '#470d61', // --colordarkpurple
  yellow: '#FFBA02', // --coloryellow
  teal: '#01564F',
  tealSolid: 'rgba(1, 86, 79, 0.92)',
  teal72: 'rgba(1, 86, 79, 0.72)',
  teal25: 'rgba(1, 86, 79, 0.25)',
  teal0: 'rgba(1, 86, 79, 0)',
};

const SIZES = {
  sm: { mark: 48, title: 'text-base', quote: 'text-sm', sub: 'text-xs', gap: 'gap-2' },
  md: { mark: 68, title: 'text-2xl', quote: 'text-lg', sub: 'text-sm', gap: 'gap-3' },
  lg: { mark: 92, title: 'text-3xl md:text-4xl', quote: 'text-xl md:text-2xl', sub: 'text-base md:text-lg', gap: 'gap-4' },
};

/** Line-art camera framed by four viewfinder brackets, as on the posters. */
function CameraMark({ size }) {
  const bracket = 'absolute w-3 h-3 border-current';
  return (
    <div className="relative inline-block" style={{ width: size, height: size * 0.72 }}>
      <span className={`${bracket} border-t-2 border-r-2 top-0 right-0`} />
      <span className={`${bracket} border-t-2 border-l-2 top-0 left-0`} />
      <span className={`${bracket} border-b-2 border-r-2 bottom-0 right-0`} />
      <span className={`${bracket} border-b-2 border-l-2 bottom-0 left-0`} />
      <svg
        viewBox="0 0 64 46"
        fill="none"
        aria-hidden="true"
        className="absolute inset-0 m-auto"
        style={{ width: '70%', height: '70%' }}
      >
        <path
          d="M6 14h9l4-6h26l4 6h9a3 3 0 0 1 3 3v22a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V17a3 3 0 0 1 3-3Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle cx="32" cy="28" r="10" stroke="currentColor" strokeWidth="2" />
        <circle cx="32" cy="28" r="4.5" stroke="currentColor" strokeWidth="2" />
        <circle cx="56" cy="19" r="1.6" fill="currentColor" />
      </svg>
    </div>
  );
}

/**
 * Campaign lockup: camera mark, title, quoted subtitle and the invitation line.
 * Arabic is intentional - this previews the public Arabic page.
 */
export function CampaignLogo({ size = 'lg', showInvite = true, className = '' }) {
  const s = SIZES[size] ?? SIZES.lg;
  return (
    <div className={`flex flex-col items-end ${s.gap} ${className}`} dir="rtl">
      <CameraMark size={s.mark} />
      <div className="text-right leading-tight">
        <div className={`${s.title} font-extrabold`}>خريف ظفار بعدستكم</div>
        <div className={`${s.quote} font-bold mt-1`}>&ldquo;شي ثاني&rdquo;</div>
        {showInvite && <div className={`${s.sub} mt-2 opacity-95`}>شاركنا صورتك في خريف ظفار</div>}
      </div>
    </div>
  );
}
